import { EventTracking, EventType } from '@app/tracking';
var GoogleAnalyticsGTag = /** @class */ (function () {
    function GoogleAnalyticsGTag(scriptPath, propertyId, anonymizeIp) {
        this.propertyId = propertyId;
        // Setup script tag
        var scriptTag = document.createElement('script');
        scriptTag.async = true;
        scriptTag.src = scriptPath + '?id=' + propertyId;
        document.body.appendChild(scriptTag);
        // Setup data layer
        window.dataLayer = window.dataLayer || [];
        window.gtag = function () {
            window.dataLayer.push(arguments);
        };
        // Initialize
        gtag('js', new Date());
        gtag('config', propertyId, { 'anonymize_ip': anonymizeIp });
        if (window.laravelDebug) {
            console.log("\u2705 Google GTag Tracking initialized for \"".concat(propertyId, "\""));
        }
        this.registerListeners();
    }
    GoogleAnalyticsGTag.prototype.registerListeners = function () {
        var _this = this;
        // Page view
        EventTracking.listen(EventType.PageView, function (_a) {
            var title = _a.title, path = _a.path, _b = _a.isFirstPageLoad, isFirstPageLoad = _b === void 0 ? false : _b;
            if (!isFirstPageLoad) {
                gtag('config', _this.propertyId, {
                    'page_title': title,
                    'page_path': path
                });
            }
        });
        // Form submit
        EventTracking.listen(EventType.FormSubmit, function (_a) {
            var form = _a.form;
            _this.sendEvent('ContactForm', 'submit', form);
        });
        // Form success
        EventTracking.listen(EventType.FormSuccess, function (_a) {
            var form = _a.form;
            _this.sendEvent('ContactForm', 'success', form);
        });
        // Form error
        EventTracking.listen(EventType.FormError, function (_a) {
            var form = _a.form, error = _a.error;
            _this.sendEvent('ContactForm', 'error', form, error);
        });
        // Locator search
        EventTracking.listen(EventType.LocatorSearch, function (_a) {
            var searchQuery = _a.searchQuery;
            _this.sendEvent('Location', 'Search', searchQuery);
        });
        // Shop Add Item
        EventTracking.listen(EventType.EcommerceAddItem, function (event) {
            _this.sendEvent('Shop', 'AddToCart', event.sku, event.price);
        });
        // Shop Add Item
        EventTracking.listen(EventType.EcommerceRemoveItem, function (event) {
            _this.sendEvent('Shop', 'RemoveFromCart', event.sku, event.price);
        });
        // Shop Go to Checkout
        EventTracking.listen(EventType.EcommerceCheckout, function (event) {
            _this.sendEvent('Shop', 'Checkout', event.id, event.total);
        });
        // Custom events
        EventTracking.listen(EventType.Track, function (_a) {
            var category = _a.category, action = _a.action, label = _a.label, _b = _a.value, value = _b === void 0 ? '' : _b;
            _this.sendEvent(category, action, label, value);
        });
    };
    GoogleAnalyticsGTag.prototype.sendEvent = function (category, action, label, value) {
        if (value === void 0) { value = ''; }
        gtag('event', action, {
            'event_category': category,
            'event_label': label,
            'value': value
        });
    };
    return GoogleAnalyticsGTag;
}());
export default GoogleAnalyticsGTag;
